import { toString, Record, Union } from "./fable_modules/fable-library.3.6.2/Types.js";
import { class_type, record_type, array_type, tuple_type, int32_type, union_type } from "./fable_modules/fable-library.3.6.2/Reflection.js";
import { tryPick as tryPick_1, find, tail, cons, singleton, append, isEmpty, head, ofSeq, exists, length, item as item_1, map as map_1, filter, ofArray } from "./fable_modules/fable-library.3.6.2/List.js";
import { comparePrimitives, min, compareArrays, getEnumerator, compare, equals, randomNext } from "./fable_modules/fable-library.3.6.2/Util.js";
import { contains, FSharpSet__get_Count, empty, remove, add, FSharpSet__Contains, ofSeq as ofSeq_1 } from "./fable_modules/fable-library.3.6.2/Set.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, enumerateWhile, choose, tryPick, toList, map as map_2, collect, delay, toArray } from "./fable_modules/fable-library.3.6.2/Seq.js";
import { rangeDouble } from "./fable_modules/fable-library.3.6.2/Range.js";
import { mapIndexed, fill, initialize } from "./fable_modules/fable-library.3.6.2/Array.js";
import { StringBuilder__Append_Z721C83C5, StringBuilder_$ctor } from "./fable_modules/fable-library.3.6.2/System.Text.js";

export const rand = {};

export class MazeElement extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Open", "Closed"];
    }
}

export function MazeElement$reflection() {
    return union_type("Domain.MazeElement", [], MazeElement, () => [[], []]);
}

export class Maze extends Record {
    constructor(size, grid) {
        super();
        this.size = size;
        this.grid = grid;
    }
}

export function Maze$reflection() {
    return record_type("Domain.Maze", [], Maze, () => [["size", tuple_type(int32_type, int32_type)], ["grid", array_type(array_type(MazeElement$reflection()))]]);
}

export function Maze__get_bounds(this$) {
    return [this$.grid.length, this$.grid[0].length];
}

export function inbounds(xBound, yBound, x, y) {
    if (((0 <= x) && (x < xBound)) && (0 <= y)) {
        return y < yBound;
    }
    else {
        return false;
    }
}

export function isPotentialConnection(x, y) {
    return (x % 2) !== (y % 2);
}

export function isPotentialPoint(x, y) {
    if ((x % 2) === 1) {
        return (y % 2) === 1;
    }
    else {
        return false;
    }
}

export class Point extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Point"];
    }
}

export function Point$reflection() {
    return union_type("Domain.Point", [], Point, () => [[["x", int32_type], ["y", int32_type], ["context", tuple_type(int32_type, int32_type)]]]);
}

export function Point__isValid(this$) {
    const y = this$.fields[1] | 0;
    const x = this$.fields[0] | 0;
    const ctx = this$.fields[2];
    if (isPotentialPoint(x, y)) {
        return inbounds(ctx[0], ctx[1], x, y);
    }
    else {
        return false;
    }
}

export class Connection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Connection"];
    }
}

export function Connection$reflection() {
    return union_type("Domain.Connection", [], Connection, () => [[["x", int32_type], ["y", int32_type], ["context", tuple_type(int32_type, int32_type)]]]);
}

export function Connection__isValid(this$) {
    const y = this$.fields[1] | 0;
    const x = this$.fields[0] | 0;
    const ctx = this$.fields[2];
    if (isPotentialConnection(x, y)) {
        return inbounds(ctx[0], ctx[1], x, y);
    }
    else {
        return false;
    }
}

export class Direction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Up", "Down", "Left", "Right"];
    }
}

export function Direction$reflection() {
    return union_type("Domain.Direction", [], Direction, () => [[], [], [], []]);
}

export function Direction_get_All() {
    return ofArray([new Direction(0), new Direction(1), new Direction(2), new Direction(3)]);
}

export function moveTo(direction, _arg1) {
    const y = _arg1.fields[1] | 0;
    const x = _arg1.fields[0] | 0;
    const tupledArg = (direction.tag === 0) ? [x, y - 2] : ((direction.tag === 2) ? [x - 2, y] : ((direction.tag === 3) ? [x + 2, y] : [x, y + 2]));
    return new Point(0, tupledArg[0], tupledArg[1], _arg1.fields[2]);
}

export function connectionTo(direction, _arg1) {
    const y = _arg1.fields[1] | 0;
    const x = _arg1.fields[0] | 0;
    const tupledArg = (direction.tag === 0) ? [x, y - 1] : ((direction.tag === 2) ? [x - 1, y] : ((direction.tag === 3) ? [x + 1, y] : [x, y + 1]));
    return new Connection(0, tupledArg[0], tupledArg[1], _arg1.fields[2]);
}

export function neighborsOf(p) {
    return filter((dest) => Point__isValid(dest), map_1((d) => moveTo(d, p), Direction_get_All()));
}

export function chooseFrom(choices) {
    return item_1(randomNext(0, length(choices)), choices);
}

export function nextTo(lhs, rhs) {
    return exists((d) => equals(moveTo(d, lhs), rhs), Direction_get_All());
}

export function where() {
    return (predicate) => ((list) => filter(predicate, list));
}

export class Bag$1 {
    constructor(items) {
        this.queue = ofSeq(items);
        this.set = ofSeq_1(items, {
            Compare: (x, y) => compare(x, y),
        });
    }
}

export function Bag$1$reflection(gen0) {
    return class_type("Domain.Bag`1", [gen0], Bag$1);
}

export function Bag$1_$ctor_BB573A(items) {
    return new Bag$1(items);
}

export function Bag$1__get_first(this$) {
    return head(this$.queue);
}

export function Bag$1__get_isEmpty(this$) {
    return isEmpty(this$.queue);
}

export function Bag$1__contains_2B595(this$, item) {
    return FSharpSet__Contains(this$.set, item);
}

export function Bag$1__add_2B595(this$, item) {
    this$.queue = append(this$.queue, singleton(item));
    this$.set = add(item, this$.set);
}

export function Bag$1__addFront_2B595(this$, item) {
    this$.queue = cons(item, this$.queue);
    this$.set = add(item, this$.set);
}

export function Bag$1__popFront(this$) {
    const v = head(this$.queue);
    this$.queue = tail(this$.queue);
    this$.set = remove(v, this$.set);
    return v;
}

export function Bag$1__remove_2B595(this$, item) {
    this$.queue = filter((y) => (!equals(item, y)), this$.queue);
    this$.set = remove(item, this$.set);
}

export function Bag$1__get_random(this$) {
    return item_1(randomNext(0, length(this$.queue)), this$.queue);
}

export function Bag$1__any_Z1D55A0D7(this$, f) {
    return exists(f, this$.queue);
}

export function Bag$1__every_Z1D55A0D7(this$, f) {
    return !exists((arg) => (!f(arg)), this$.queue);
}

export function Bag$1__firstWhere_Z1D55A0D7(this$, f) {
    return find(f, this$.queue);
}

export function Bag$1__where_Z1D55A0D7(this$, f) {
    return filter(f, this$.queue);
}

export function nodesOf(maze) {
    const patternInput = maze.size;
    return toArray(delay(() => collect((x_2) => map_2((y_2) => {
        const tupledArg = [x_2, y_2];
        const p = new Point(0, (tupledArg[0] * 2) - 1, (tupledArg[1] * 2) - 1, Maze__get_bounds(maze));
        if (!Point__isValid(p)) {
            throw (new Error(`Invalid point: ${p}`));
        }
        return p;
    }, rangeDouble(1, 1, patternInput[1])), rangeDouble(1, 1, patternInput[0]))));
}

export function newMaze(width, height, initialConnection) {
    const grid = initialize((width * 2) + 1, (_arg1) => fill(new Array((height * 2) + 1), 0, (height * 2) + 1, new MazeElement(1)));
    const enumerator = getEnumerator(toList(rangeDouble(1, 2, width * 2)));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const x = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
            const enumerator_1 = getEnumerator(toList(rangeDouble(1, 2, height * 2)));
            try {
                while (enumerator_1["System.Collections.IEnumerator.MoveNext"]()) {
                    const y = enumerator_1["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                    grid[x][y] = (new MazeElement(0));
                }
            }
            finally {
                enumerator_1.Dispose();
            }
        }
    }
    finally {
        enumerator.Dispose();
    }
    if (initialConnection) {
        const enumerator_2 = getEnumerator(toList(rangeDouble(2, 2, (width * 2) - 2)));
        try {
            while (enumerator_2["System.Collections.IEnumerator.MoveNext"]()) {
                const x_1 = enumerator_2["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                const enumerator_3 = getEnumerator(toList(rangeDouble(1, 2, height * 2)));
                try {
                    while (enumerator_3["System.Collections.IEnumerator.MoveNext"]()) {
                        const y_1 = enumerator_3["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                        grid[x_1][y_1] = (new MazeElement(0));
                    }
                }
                finally {
                    enumerator_3.Dispose();
                }
            }
        }
        finally {
            enumerator_2.Dispose();
        }
        const enumerator_4 = getEnumerator(toList(rangeDouble(1, 2, width * 2)));
        try {
            while (enumerator_4["System.Collections.IEnumerator.MoveNext"]()) {
                const x_2 = enumerator_4["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                const enumerator_5 = getEnumerator(toList(rangeDouble(2, 2, (height * 2) - 2)));
                try {
                    while (enumerator_5["System.Collections.IEnumerator.MoveNext"]()) {
                        const y_2 = enumerator_5["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                        grid[x_2][y_2] = (new MazeElement(0));
                    }
                }
                finally {
                    enumerator_5.Dispose();
                }
            }
        }
        finally {
            enumerator_4.Dispose();
        }
    }
    return new Maze([width, height], grid);
}

export function map(f, maze) {
    return new Maze(maze.size, mapIndexed((x, column) => mapIndexed((y, state) => f(x, y, state), column), maze.grid));
}

export function permute(percent, maze) {
    const grid = maze.grid;
    return map((x_1, y_1, state) => {
        let y, x, patternInput;
        if ((Connection__isValid(new Connection(0, x_1, y_1, Maze__get_bounds(maze))) && ((y = (y_1 | 0), (x = (x_1 | 0), (patternInput = [grid.length - 2, grid[0].length - 2], (((0 < x) && (x < patternInput[0])) && (0 < y)) && (y < patternInput[1])))))) && (randomNext(0, 100) < percent)) {
            if (state.tag === 1) {
                return new MazeElement(0);
            }
            else {
                return new MazeElement(1);
            }
        }
        else {
            return state;
        }
    }, maze);
}

export function carve(percent, maze) {
    const grid = maze.grid;
    return map((x_1, y_1, state) => {
        let y, x, patternInput;
        if ((Connection__isValid(new Connection(0, x_1, y_1, Maze__get_bounds(maze))) && ((y = (y_1 | 0), (x = (x_1 | 0), (patternInput = [grid.length - 2, grid[0].length - 2], (((0 < x) && (x < patternInput[0])) && (0 < y)) && (y < patternInput[1])))))) && (randomNext(0, 100) < percent)) {
            if (state.tag === 1) {
                return new MazeElement(0);
            }
            else {
                return new MazeElement(0);
            }
        }
        else {
            return state;
        }
    }, maze);
}

export function randomConnected(maze) {
    const patternInput = maze.size;
    const toPoint = (tupledArg) => {
        const p = new Point(0, (tupledArg[0] * 2) - 1, (tupledArg[1] * 2) - 1, Maze__get_bounds(maze));
        if (!Point__isValid(p)) {
            throw (new Error(`Invalid point: ${p}`));
        }
        return p;
    };
    const nodes = toArray(delay(() => collect((y_2) => map_2((x_2) => toPoint([x_2, y_2]), rangeDouble(1, 1, patternInput[0])), rangeDouble(1, 1, patternInput[1]))));
    let connectedNodes = ofSeq_1([toPoint([1, 1])], {
        Compare: (x_3, y_3) => compare(x_3, y_3),
    });
    let tunnels = empty({
        Compare: (x_4, y_4) => compareArrays(x_4, y_4),
    });
    while (FSharpSet__get_Count(connectedNodes) < nodes.length) {
        const nextIx = randomNext(0, nodes.length) | 0;
        const candidate = nodes[nextIx];
        if (!FSharpSet__Contains(connectedNodes, candidate)) {
            const start = candidate;
            const matchValue = tryPick((dest) => tryPick_1((dir) => {
                if (equals(moveTo(dir, start), dest)) {
                    return [dir, dest];
                }
                else {
                    return void 0;
                }
            }, ofArray([new Direction(0), new Direction(1), new Direction(2), new Direction(3)])), connectedNodes);
            if (matchValue == null) {
            }
            else {
                const dest_1 = matchValue[1];
                const patternInput_1 = connectionTo(matchValue[0], start);
                tunnels = add([patternInput_1.fields[0], patternInput_1.fields[1]], tunnels);
                connectedNodes = add(candidate, connectedNodes);
            }
        }
    }
    return map((x_7, y_7, state) => {
        if (contains([x_7, y_7], tunnels)) {
            return new MazeElement(0);
        }
        else {
            return state;
        }
    }, maze);
}

export function toAscii(maze) {
    const s = StringBuilder_$ctor();
    StringBuilder__Append_Z721C83C5(s, "\n");
    for (let y = 0; y <= (maze.grid[0].length - 1); y++) {
        for (let x = 0; x <= (maze.grid.length - 1); x++) {
            StringBuilder__Append_Z721C83C5(s, equals(maze.grid[x][y], new MazeElement(1)) ? "x" : " ");
        }
        StringBuilder__Append_Z721C83C5(s, "\n");
    }
    return toString(s);
}

export function doAlgorithm(algorithm, maze) {
    let tunnels = ofSeq_1(choose((_arg1) => {
        if (Connection__isValid(_arg1)) {
            return [_arg1.fields[0], _arg1.fields[1]];
        }
        else {
            return void 0;
        }
    }, algorithm(Bag$1_$ctor_BB573A(nodesOf(maze)))), {
        Compare: (x_2, y_2) => compareArrays(x_2, y_2),
    });
    const perimeter = toArray(delay(() => collect((x_3) => (((x_3 === 0) ? true : (x_3 === (maze.grid.length - 1))) ? map_2((y_3) => [x_3, y_3], rangeDouble(0, 1, maze.grid[x_3].length - 1)) : map_2((y_4) => [x_3, y_4], [0, maze.grid[x_3].length - 1])), rangeDouble(0, 1, maze.grid.length - 1)))).filter((tupledArg) => Connection__isValid(new Connection(0, tupledArg[0], tupledArg[1], Maze__get_bounds(maze))));
    const entry = perimeter[randomNext(0, perimeter.length)];
    let exit;
    const retry = () => {
        let tupledArg_2, tupledArg_1;
        const candidate = perimeter[randomNext(0, perimeter.length)];
        const patternInput = maze.size;
        if (((tupledArg_2 = entry, (tupledArg_1 = candidate, Math.abs(tupledArg_1[0] - tupledArg_2[0]) + Math.abs(tupledArg_1[1] - tupledArg_2[1])))) < (~(~(min((x_6, y_7) => comparePrimitives(x_6, y_7), patternInput[0], patternInput[1]) / 2)))) {
            return retry();
        }
        else {
            return candidate;
        }
    };
    exit = retry();
    tunnels = add(exit, add(entry, tunnels));
    return map((x_7, y_8, state) => {
        if (contains([x_7, y_8], tunnels)) {
            return new MazeElement(0);
        }
        else {
            return state;
        }
    }, maze);
}

export function connect(_arg2, _arg1) {
    return new Connection(0, ~(~((_arg2.fields[0] + _arg1.fields[0]) / 2)), ~(~((_arg2.fields[1] + _arg1.fields[1]) / 2)), _arg2.fields[2]);
}

export function aldousBroder(unvisited) {
    return delay(() => {
        let currentNode = Bag$1__popFront(unvisited);
        return enumerateWhile(() => (!Bag$1__get_isEmpty(unvisited)), delay(() => {
            const dest = chooseFrom(neighborsOf(currentNode));
            return append_1(Bag$1__contains_2B595(unvisited, dest) ? ((Bag$1__remove_2B595(unvisited, dest), singleton_1(connect(currentNode, dest)))) : empty_1(), delay(() => {
                currentNode = dest;
                return empty_1();
            }));
        }));
    });
}

export class HunterKillerMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Hunt", "Kill"];
    }
}

export function HunterKillerMode$reflection() {
    return union_type("Domain.HunterKillerMode", [], HunterKillerMode, () => [[], []]);
}

export function hunterKiller(unvisited) {
    return toList(delay(() => {
        let mode = new HunterKillerMode(1);
        let currentNode = Bag$1__popFront(unvisited);
        const visited = Bag$1_$ctor_BB573A([currentNode]);
        return enumerateWhile(() => (!Bag$1__get_isEmpty(unvisited)), delay(() => {
            if (mode.tag === 0) {
                currentNode = Bag$1__get_random(visited);
                const matchValue = where()((n) => Bag$1__contains_2B595(unvisited, n))(neighborsOf(currentNode));
                if (isEmpty(matchValue)) {
                    return empty_1();
                }
                else {
                    const dest = chooseFrom(matchValue);
                    return append_1(singleton_1(connect(currentNode, dest)), delay(() => {
                        Bag$1__remove_2B595(unvisited, dest);
                        Bag$1__add_2B595(visited, dest);
                        currentNode = dest;
                        mode = (new HunterKillerMode(1));
                        return empty_1();
                    }));
                }
            }
            else {
                const candidate = chooseFrom(neighborsOf(currentNode));
                if (Bag$1__contains_2B595(unvisited, candidate)) {
                    return append_1(singleton_1(connect(currentNode, candidate)), delay(() => {
                        Bag$1__remove_2B595(unvisited, candidate);
                        Bag$1__add_2B595(visited, candidate);
                        currentNode = candidate;
                        return empty_1();
                    }));
                }
                else {
                    mode = (new HunterKillerMode(0));
                    return empty_1();
                }
            }
        }));
    }));
}

export function normalize(maze) {
    return map((x, y, state) => {
        if (!(Connection__isValid(new Connection(0, x, y, Maze__get_bounds(maze))) ? true : Point__isValid(new Point(0, x, y, Maze__get_bounds(maze))))) {
            const within = (start, finish, n) => {
                if (compare(start, n) <= 0) {
                    return compare(n, finish) < 0;
                }
                else {
                    return false;
                }
            };
            if (exists((_arg1) => {
                let pattern_matching_result;
                if (_arg1 != null) {
                    if (_arg1.tag === 1) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return true;
                    }
                    case 1: {
                        return false;
                    }
                }
            }, map_1((tupledArg) => {
                const x_1 = tupledArg[0] | 0;
                const y_1 = tupledArg[1] | 0;
                if (within(0, maze.grid.length, x_1) && within(0, maze.grid[x_1].length, y_1)) {
                    return maze.grid[x_1][y_1];
                }
                else {
                    return void 0;
                }
            }, ofArray([[x + 1, y], [x - 1, y], [x, y + 1], [x, y - 1]])))) {
                return new MazeElement(1);
            }
            else {
                return new MazeElement(0);
            }
        }
        else {
            return state;
        }
    }, maze);
}

